export const gameConst = {
    refill: {
        amount: 1,
        time: 8
    },
    primogemRefill: {
        amount: 60,
        cost: [0,50, 150, 250, 400, 600, 800]
    },
    leyLineCost: 20,
    bossCost : 40,
    moraCostbyEXp : 1/5
}
 // export default gameConst